import * as Sentry from '@sentry/react'

const sendToSentry = (error: Error) => {
    if (error.message === 'Request aborted') return
    Sentry.captureException(error)
}

export const useSentryError = () => {
    const handleError = (error: unknown, context = '') => {
        sendToSentry(error as Error)
        console.trace(`Error ${context}:`, error)
    }

    return { handleError }
}
